import React from 'react';
import { Button, Input, Label, Row, Col, FormGroup } from 'reactstrap';
import Contact from 'components/Contact';
import api from '../../api';
import _ from 'lodash';
import './index.css';

export default class LocationContactView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      locationContact: {},
      locationContacts: [],
      contact: {},
      contactSearchResults: [],
      currentUser: null,
    };
    this.search = _.debounce(this.search, 300);
    this.getLocationContact = this.getLocationContact.bind(this);
  }
  componentDidMount() {
    this.getCurrentUser();
    this.getLocationContact();
  }
  getCurrentUser() {
    api.fetchAPI({
      method: 'get',
      uri: `userme/me`,
      success: (response) => {
        console.log(response);
        if (response.result) {
          const currentUser = response.result;
          this.setState({
            currentUser,
          });
        } else {
          alert('Failed to get user: ' + response.msg);
        }
      },
      error: (error) => {
        console.error(error);
      }
    });
  }
  getLocationContact() {
    const { locationId } = this.props;
    if (!locationId) return;
    api.fetchAPI({
      method: 'get',
      uri: `location_contact/?q=(filters:!((col:location,opr:rel_o_m,value:${locationId}),(col:is_active,opr:eq,value:1)))`,
      success: (response) => {
        console.log(response);
          if (response.result) {
            this.setState({
              locationContacts: response.result,
              isCreateNewContact: false,
            });
          } else {
            alert(response.msg);
          }
      },
    });
  }
  addContactToLocation(contactToAdd) {
    const { locationId } = this.props;
    const { currentUser } = this.state;

    const locationContactToUpload = {
      location: {
        id: locationId,
      },
      contact: {
        id: contactToAdd.id,
      },
      created_by: {
        id: currentUser.id,
      },
      changed_by: {
        id: currentUser.id,
      },
    };
  
    api.fetchAPI({
      method: 'post',
      // body: locationContactToUpload,
      uri: 'location_contact/',
      body: locationContactToUpload,
      success: (response) => {
        if (response.result) {
          locationContactToUpload.id = response.id;
          this.setState({
            isSearchForExistingContact: false,
          }, this.getLocationContact);
        } else {
          alert(response.msg);
        }
      },
    });
  }
  searchForContact(keywords) {
    this.setState({
      keywords,
    }, this.search);
  }
  search() {
    const { keywords } = this.state;
    if (!keywords) return;
    api.fetchAPI({
      method: 'get',
      uri: `contact/search?q=${keywords}`,
      success: (response) => {
        if (response.result) {
          this.setState({
            contactSearchResults: response.result.result,
          });
        }
      }
    });
  }
  render() {
    const { locationId } = this.props;
    const {
      locationContacts, isCreateNewContact, isSearchForExistingContact, contactSearchResults,
    } = this.state;
    return (
      <div>
        <Row>
          <Col xs={12}>
            <FormGroup>
              <Button
                color="success"
                onClick={() => this.setState({ isCreateNewContact: true })}
              >
                Tạo mới
              </Button>
              <Button
                color="primary"
                onClick={() => this.setState({ isSearchForExistingContact: true })}
              >
                Add chủ nhà có sẵn
              </Button>
            </FormGroup>
          </Col>
        </Row>
        {isSearchForExistingContact &&
          <Row>
            <Col xs={12}>
              <FormGroup>
                <Input
                  type="text"
                  placeholder="Gõ tên, họ hoặc số điện thoại"
                  onChange={(e) => this.searchForContact(e.target.value)}
                />
              </FormGroup>
            </Col>
          </Row>
        }
        {isSearchForExistingContact && contactSearchResults &&
          <Row>
            {contactSearchResults.map((contactSearchResult, index) => (
              <Col xs={12} key={index}>
                <div>
                  <h4>{contactSearchResult.last_name} {contactSearchResult.middle_name} {contactSearchResult.first_name}</h4>
                  <p>Số điện thoại chính: {contactSearchResult.primary_phone}</p>
                  <FormGroup>
                    <Button
                      size="sm"
                      color="primary"
                      onClick={() => this.addContactToLocation(contactSearchResult)}
                    >Thêm</Button>
                  </FormGroup>
                </div>
              </Col>
            ))}
          </Row>
        }
        {isCreateNewContact &&
          <Contact
            locationId={locationId}
            isCreateNewContact={isCreateNewContact}
            onContactCreated={this.getLocationContact}
          />
        }
        {locationContacts.map(locationContact => (
          <div key={locationContact.id}>
            <Contact locationId={locationId} locationContact={locationContact} />
          </div>
        ))}
      </div>
    );
  }
}